import { useTransition } from "common/hooks";
import { stopPropagation } from "common/utils";

import ModalPortal from "./ModalPortal";
import Overlay from "./Overlay";

import styles from "../../styles/deprecated/Modal.module.less";

export type ModalProps = {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

/**
 * @deprecated Replaced by Drawer stackables
 * @see {@link stackables/hooks!useDrawer} for new implementation
 */
const Modal = (props: ModalProps) => {
  const { visible, onClose, children } = props;

  const transition = useTransition(visible);

  if (!transition.isMounted) {
    return null;
  }

  return (
    <ModalPortal>
      <Overlay onClose={onClose} transition={transition} className={styles.container}>
        <div
          className={`${styles.box} ${styles[`box-${transition.transitionState}`]}`}
          onMouseDown={stopPropagation}
          onClick={stopPropagation}
          role="presentation"
        >
          <div className={styles.content}>{children}</div>
        </div>
      </Overlay>
    </ModalPortal>
  );
};

export default Modal;
